import { useEffect, useState } from "react";
import { toast } from "sonner";
import { depositStatus, uploadDeposit } from "@/lib/depotApi";
import { downloadElementAsPdf, elementsToPdfBlob } from "@/lib/pdf";

const tokenFrom = (str) => { const m = String(str || "").trim().match(/(?:depot[=/]|^)([A-Za-z0-9_-]{6,})$/); return m ? m[1] : ""; };

// Dépôt praticien : token lu dans l'URL (?depot=) ou mémorisé ; transmission PDF uniquement sur action volontaire.
export function useDepot(storageKey) {
  const [depot, setDepot] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("depot");
    if (q) localStorage.setItem(storageKey, q);
    return { token: q || localStorage.getItem(storageKey) || "", status: null };
  });
  const [askToken, setAskToken] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!depot.token) return;
    depositStatus(depot.token).then((r) => setDepot((d) => ({ ...d, status: !r.found ? "invalid" : r.expired ? "expired" : r.status }))).catch(() => setDepot((d) => ({ ...d, status: "invalid" })));
  }, [depot.token]);
  const ready = Boolean(depot.token) && depot.status === "pending";

  const download = async (el, filename, footer) => { setBusy(true); try { await downloadElementAsPdf(el, filename, { footer }); toast.success("PDF téléchargé"); } catch { toast.error("Export impossible"); } finally { setBusy(false); } };
  const share = async (el, filename, footer, title) => {
    const makeFile = async () => new File([await elementsToPdfBlob([el], { footer, filename })], filename, { type: "application/pdf" });
    if (ready) {
      setBusy(true);
      try { await uploadDeposit(depot.token, await makeFile()); setDepot((d) => ({ ...d, status: "received" })); toast.success("Synthèse transmise à votre thérapeute", { description: "Elle est déposée dans son espace sécurisé." }); }
      catch (e) { const st = e?.response?.status; toast.error(st === 410 ? "Ce lien de dépôt a expiré" : st === 404 ? "Lien de dépôt invalide" : "Transmission impossible, réessayez"); if (st === 410 || st === 404) setDepot((d) => ({ ...d, status: st === 410 ? "expired" : "invalid" })); }
      finally { setBusy(false); }
      return;
    }
    if (!depot.token || depot.status === "invalid" || depot.status === "expired") { setAskToken(true); return; }
    setBusy(true);
    try {
      const file = await makeFile();
      if (navigator.canShare && navigator.canShare({ files: [file] })) await navigator.share({ files: [file], title });
      else { await downloadElementAsPdf(el, filename, { footer }); toast("PDF téléchargé", { description: "Transmettez-le à votre thérapeute via le lien de dépôt qu'il vous a remis, ou apportez-le en séance." }); }
    } catch { /* annulé */ } finally { setBusy(false); }
  };
  const applyToken = (pasted) => { const tk = tokenFrom(pasted); if (!tk) { toast.error("Lien non reconnu"); return false; } localStorage.setItem(storageKey, tk); setDepot({ token: tk, status: null }); setAskToken(false); return true; };
  return { depot, ready, busy, askToken, setAskToken, download, share, applyToken };
}
